import Dashboards from '@highcharts/dashboards/es-modules/masters/dashboards.src.js';
import '@highcharts/dashboards/es-modules/masters/modules/layout.src.js';
import Highcharts from 'highcharts/esm/highcharts';
import 'highcharts/esm/modules/accessibility';
import 'highcharts/esm/modules/heatmap';
import 'highcharts/esm/modules/map';

export { Dashboards, Highcharts };

let registered = false;

/**
 * Wires Highcharts into Dashboards.
 *
 * Idempotent: all boards share one Dashboards singleton.
 */
export function registerDashboardsPlugins(): void {
    if (registered) {
        return;
    }

    Dashboards.HighchartsPlugin.custom.connectHighcharts(Highcharts);

    Dashboards.PluginHandler.addPlugin(Dashboards.HighchartsPlugin);

    Highcharts.setOptions({
        credits: { enabled: false },
        /* Styled mode stops Highcharts writing colors onto the chart and makes it read them from CSS instead */
        chart: { colorCount: 6, styledMode: true },
        colorAxis: {
            stops: [
                [0, 'var(--chart-sequential-01)'],
                [0.25, 'var(--chart-sequential-02)'],
                [0.5, 'var(--chart-sequential-03)'],
                [0.75, 'var(--chart-sequential-04)'],
                [1, 'var(--chart-sequential-05)'],
            ],
        },
    });

    registered = true;
}
